/**
 * Sidebar Subscription Card Component
 * Displays current subscription/trial status, cycle information, and upgrade button in the sidebar
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../../Context/SubscriptionContext';
import './SidebarSubscriptionCard.css';

const SidebarSubscriptionCard = () => {
  const navigate = useNavigate();
  const {
    subscriptionStatus,
    isTrialActive,
    isTrialExpired,
    planName,
    trialEnd,
    subscriptionCurrentPeriodEnd,
    daysUntilExpiry,
    loading,
  } = useSubscription();

  // Calculate days left in trial
  const calculateDaysLeft = () => {
    if (!trialEnd) return 0;
    const endDate = new Date(trialEnd);
    const now = new Date();
    const diffTime = endDate - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return Math.max(0, diffDays);
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const daysLeft = calculateDaysLeft();

  // Don't show anything while loading
  if (loading) {
    return null;
  }

  // Determine status text and cycle info
  let statusText = '';
  let cycleInfo = null;

  if (subscriptionStatus === 'active') {
    statusText = planName ? `Plan: ${planName}` : 'Active subscription';
    
    // Show next billing date / renewal date
    if (subscriptionCurrentPeriodEnd) {
      const nextBillingDate = formatDate(subscriptionCurrentPeriodEnd);
      if (daysUntilExpiry !== null) {
        cycleInfo = `Renews in ${daysUntilExpiry} ${daysUntilExpiry === 1 ? 'day' : 'days'} (${nextBillingDate})`;
      } else {
        cycleInfo = `Next billing: ${nextBillingDate}`;
      }
    }
  } else if (isTrialActive) {
    statusText = `Free trial – ${daysLeft} days left`;
    cycleInfo = `Limit: 100 animals`;
  } else if (isTrialExpired && subscriptionStatus !== 'active') {
    statusText = 'Trial ended';
  } else {
    statusText = 'No active subscription';
  }

  // Determine button text and action
  const buttonText = subscriptionStatus === 'active' ? 'Change plan' : 'Upgrade now';
  const handleButtonClick = () => {
    navigate('/subscription/plans');
  };

  return (
    <div className="sidebar-subscription-card">
      <div className="subscription-status">
        <p className="status-text">{statusText}</p>
        {cycleInfo && <p className="cycle-info">{cycleInfo}</p>}
      </div>
      <button 
        className="upgrade-button"
        onClick={handleButtonClick}
        type="button"
        
        >
        {buttonText}
      </button>
    </div>
  );
};

export default SidebarSubscriptionCard;

